export { default as WebCapture } from "./web-capture.component";
export { default as Lead } from "./lead.component";
export { default as LeadBody } from "./lead-body.component";